import api from "@/lib/api";

const CHUNK = 4 * 1024 * 1024;
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

async function putChunks(uploadId, file, onPct) {
  const chunks = Math.max(1, Math.ceil(file.size / CHUNK));
  for (let i = 0; i < chunks; i++) {
    for (let attempt = 1; ; attempt++) {
      try {
        await api.put(`/uploads/${uploadId}/chunk?index=${i}`, file.slice(i * CHUNK, (i + 1) * CHUNK), { headers: { "Content-Type": "application/octet-stream" } });
        break;
      } catch (e) { if (attempt >= 3) throw e; await sleep(800 * attempt); }
    }
    onPct(Math.round(((i + 1) / chunks) * 100));
  }
}

// Chunked upload into a bid's documents; resolves with the filed documents once processing is done.
export async function uploadToBid(bidId, file, { folderId = null, onState = () => {} } = {}) {
  const { data: { upload_id } } = await api.post(`/bids/${bidId}/uploads/init`, { filename: file.name, size: file.size, folder_id: folderId });
  await putChunks(upload_id, file, (pct) => onState({ status: "uploading", pct }));
  const { data } = await api.post(`/bids/${bidId}/uploads/${upload_id}/complete`, { filename: file.name, content_type: file.type || "application/octet-stream", folder_id: folderId });
  if (!data.job_id) return data.documents || [];
  onState({ status: "processing", pct: 100 });
  for (let misses = 0; misses < 90;) {
    await sleep(2000);
    let st;
    try { st = (await api.get(`/bids/${bidId}/uploads/${data.job_id}/status`)).data; } catch { misses++; continue; }
    if (st.status === "done") return st.documents || [];
    if (st.status === "failed") throw new Error(st.error || "Could not process the file");
  }
  throw new Error("The file is still processing. Check the bid's documents in a minute.");
}
